import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import Select, { createFilter } from 'react-select';
import { connect } from 'react-redux';
import { reactSelectCustomStyleCms } from "helper";
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  setFormData,
  formData,
  history,
  id,
  updating,
  updateOTPSettings,
  showOTPSettings,
}) {
  const setModal = useContext(ModalContext);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    updateOTPSettings(id, formData, ({ data }) => {
      setModal({ isOpen: false });
      showOTPSettings(id);
      history.push(`/general-settings/otp-modules/${_.get(data, 'id')}`);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row px-4">
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-1" style={{ fontStize: '12px', color: '#484848' }}>
             Change Mobile Number:
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              styles={reactSelectCustomStyleCms()}
              name="change_mobile_number"
              placeholder="Select Status"
              onChange={handleChangeSelect('change_mobile_number')}
              options={c.OTP_OPTIONS}
              value={
                _.get(formData, 'change_mobile_number')
                  ? {
                      value: _.get(formData, 'change_mobile_number'),
                      label: _.get(formData, 'change_mobile_number') === "0" ? "Inactive" : "Active",
                    }
                  : { value: '', label: 'Please Select a type'}
              }
            />
          </div>
          <div className="form-group col-12">
            <label htmlFor="zone" className="full-label mb-1" style={{ fontStize: '12px', color: '#484848' }}>
             Registration of Account:
            </label>
            <Select
              filterOption={createFilter({
                ignoreAccents: false,
              })}
              styles={reactSelectCustomStyleCms()}
              name="register_account"
              placeholder="Select status"
              onChange={handleChangeSelect('register_account')}
              options={c.OTP_OPTIONS}
              value={
                _.get(formData, 'register_account')
                  ? {
                      value: _.get(formData, 'register_account'),
                      label: _.get(formData, 'register_account') === "0" ? "Inactive" : "Active",
                    }
                  : { value: '', label: 'Please Select a type'}
              }
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark mr-2"
          >
            <span className="font-weight-bold px-3">Cancel</span>
          </button>
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary "
          >
            <span className="font-weight-bold px-3">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,

  updateOTPSettings: PropTypes.instanceOf(Function).isRequired,
  showOTPSettings: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_OTP_SETTINGS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
